import React, { useState, useEffect } from 'react';

import {Layer, Source, useMap} from 'react-map-gl';

import { callGetFeatureJson } from '../../api/jsonFeatureApi';
import { selectedTransportLineLayer } from '../../mapStyles';

const selectedTransportStyle = selectedTransportLineLayer(4); 

const FeatureTransportLine = ({feature, index, layerID}) => {
  const [apiFeature, setApiFeature] = useState(null);
  useEffect(() => {
    callGetFeatureJson(layerID, feature.properties.fid).then(
      result => {
        setApiFeature(result);
      }
    ).catch(error => {
      console.log('error', error);
    });
  }, [feature]);

  return (
    <Source key={`selected_transport_${index}`} id={`selectedTransport_${index}`}  type='geojson' data={apiFeature}>
      <Layer 
        key={`selected_transport_layer_${index}`}  
        id={`selected_transport_layer_${index}`} 
        beforeId='lignes_transports_symbols'
        {...selectedTransportStyle} />
    </Source>
  
  );
};

export const FeatureTransportLines = ({features, layer_id}) => {
  
  const { mymap } =  useMap();

  const renderFeatureTransportLines = () => {
    if(features.length > 0) {
      return (
        <>
          {features.map((feature, index) => {
            return (
              <FeatureTransportLine key={index} feature={feature} index={index} layerID={layer_id} />
            );
          })}
        </>
      );
    } else {
      return (
        <FeatureTransportLine feature={features} index={0} layerID={layer_id}/>
      );
    }
  };

  return (
    <>
      {mymap && (renderFeatureTransportLines())}
    </>
  );
};
